import { ReactNode } from 'react'
import InfoTip from '../../../components/novarium/InfoTip'

interface IndicatorCardProps {
  label: string
  /** El valor ya escrito; con `onDrill` es un botón que abre la lista. */
  value: string
  /** Fórmula del indicador y qué valida el servicio (ⓘ, a demanda). */
  hint: string
  /** Abre la lista con las cirugías que cuenta el número; sin él, el valor es solo texto. */
  onDrill?: () => void
  /** Renglones de detalle: el desglose y la variación contra el período anterior. */
  details?: ReactNode[]
}

/**
 * Una tarjeta de indicador: nombre con su ⓘ a demanda, el valor (un botón si abre la lista) y renglones de detalle. Sin detalle
 * deja un renglón vacío para que las tarjetas de una fila midan lo mismo. La comparten los indicadores del período y las
 * pestañas Tiempos y Anulaciones.
 */
export default function OperatingRoomIndicatorCard({ label, value, hint, onDrill, details = [] }: IndicatorCardProps) {
  return (
    <dl className="nv-card nv-or-ind">
      <dt className="nv-or-ind__label">
        {label}
        <InfoTip text={hint} />
      </dt>
      <dd className="nv-kpi">
        {onDrill
          ? <button type="button" className="nv-or-drill nv-or-drill--kpi" onClick={onDrill}>{value}</button>
          : value}
      </dd>
      {details.length === 0 && <dd className="nv-or-ind__detail">{' '}</dd>}
      {details.map((detail, index) => <dd key={index} className="nv-or-ind__detail">{detail}</dd>)}
    </dl>
  )
}
